export const GET_GROUPS = 'cvf-admin/groups/GET_GROUPS';
export const ADD_GROUP = 'cvf-admin/groups/ADD_GROUP';
export const UPDATE_GROUP_INSTANCES = 'cvf-admin/groups/UPDATE_GROUP_INSTANCES';
export const UPDATE_GROUP_INSTANCE_STATUSES =
  'cvf-admin/groups/UPDATE_GROUP_INSTANCE_STATUSES';

export const getGroups = (payload) => ({
  type: GET_GROUPS,
  payload
});

export const addGroup = (payload) => ({
  type: ADD_GROUP,
  payload
});

// both of these actions may be redundant
export const updateGroupInstances = (payload) => ({
  type: UPDATE_GROUP_INSTANCES,
  payload
});

export const updateGroupInstanceStatuses = (payload) => ({
  type: UPDATE_GROUP_INSTANCE_STATUSES,
  payload
});
